import { axiosInstance } from './api'

import { Campaign, POSTCampaign, POSTCampaignPlaces, POSTCampaignRule, PUTCampaign } from 'types/campaign'
import { EntityPage, Paging } from 'types/paging'
import { SceneGET } from 'types/scenes'
import { StatisticsToInfoCard } from 'types/stats'

import { Intervals, createIntervalFromString } from 'utils/createIntervalFromString'

export const campaignsApi = {
  create(params: POSTCampaign) {
    return axiosInstance.post(`ad-campaigns/create`, params)
  },
  paging(params: Paging) {
    return axiosInstance.post<EntityPage<Campaign>>(`ad-campaigns/paging`, params)
  },
  getOne(id: number) {
    return axiosInstance.get<Campaign>(`ad-campaigns/${id}`)
  },
  update(id: number, params: PUTCampaign) {
    return axiosInstance.put(`ad-campaigns/${id}`, params)
  },
  delete(id: number) {
    return axiosInstance.delete(`ad-campaigns/${id}`)
  },
  start(id: number) {
    return axiosInstance.post(`ad-campaigns/${id}/start`, { strict: true })
  },
  getStats(id: number, interval: Intervals) {
    return axiosInstance.post<StatisticsToInfoCard>(`ad-campaigns/${id}/stats`, createIntervalFromString(interval))
  },
  getScenes(id: number) {
    return axiosInstance.get<{ scenes: SceneGET[] }>(`ad-campaigns/${id}/scenes`)
  },
  postPlaces(id: number, params: POSTCampaignPlaces) {
    return axiosInstance.post(`ad-campaigns/${id}/places`, { ad_campaign_places: params })
  },
  deletePlace(id: number, placeId: number) {
    return axiosInstance.delete(`ad-campaigns/${id}/places/${placeId}`)
  },
  postCampRules(id: number, params: POSTCampaignRule[]) {
    return axiosInstance.post(`ad-campaigns/${id}/rules`, { campaign_rules: params })
  },
  deleteCampRule(id: number, ruleId: number) {
    return axiosInstance.delete(`ad-campaigns/${id}/rules/${ruleId}`)
  },
}
